/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../atoms/checkbox/css/checkbox';
import './checkbox-group.scss';
import './modifier/vertical-group.scss';
